module.exports = __webpack_public_path__ + "om.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/om.svg
// module id = 745
// module chunks = 0